module.exports = __webpack_public_path__ + "img/clock-one-color-icon.546929ab.svg";